import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FavIconService } from './services/fav-icon.service';

// Rutas donde el footer global NO debe mostrarse
const AUTH_ROUTES = ['/', '/client'];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'crm-front';
  showFooter = true;

  constructor(private faviconService: FavIconService, private router: Router){
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: any) => {
      this.showFooter = !AUTH_ROUTES.includes(e.urlAfterRedirects);
    });
  }
}
